export default __webpack_public_path__ + "static/media/add-file.cacdd5c8.svg";